export const NEW_CHAT = "newChat"